import type { NavigationGuard, NavigationGuardNext, Route } from 'vue-router';

import baseStore from '@/main/baseStore';

import { VueRouteTokenTransitionGuardService } from './transition-guard';
import type { TokenValidator } from './token-manager';

function makeTokenValidatorGuard(validator: TokenValidator): NavigationGuard {
    return (to: Route, _: Route, next: NavigationGuardNext) => {
        const guardService = new VueRouteTokenTransitionGuardService(to, next);
        guardService.verifyTokenTransition(validator, baseStore);
    };
}

export { makeTokenValidatorGuard as makeTokenCheckerGuard };
